import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import styles from './index.module.scss';
import { images } from 'utils/icons';
import { BorderedCloseIcon } from 'Icons';
import cn from 'classnames';
import Portal from 'portal/Portal';
import { makeStyles } from '@material-ui/core/styles';
import IconWithText from 'components/IconWithText/iconWithText';

const downloadMedia = url => {
  window.open(url);
};
const useStyles = makeStyles(theme => ({
  header: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    width: '100%',
    height: '40px',
    justifyContent: 'flex-end',
  },
}));
const MediaButton = ({ value }) => {
  const [mediaPlay, setMediaPlay] = useState(false);
  const [displayPortal, setdisplayPortal] = useState(false);
  const musicRef = useRef(null);
  const classes = useStyles();
  const handleMediaPlay = () => {
    if (mediaPlay) {
      musicRef.current.pause();
      setMediaPlay(false);
    } else {
      musicRef.current.play();
      setMediaPlay(true);
    }
    musicRef.current.onended = () => {
      setMediaPlay(false);
    };
  };
  const openPortal = () => {
    setdisplayPortal(true);
  };
  const closePortal = () => {
    setdisplayPortal(false);
  };

  const renderContent = value => {
    // render audio
    if (value && typeof value === 'string' && value.includes('/audio')) {
      return (
        <div key={'audio-key'}>
          <audio ref={musicRef}>
            <source src={value} type="audio/mpeg" />
            <Image src={images.downloadMedia.default} onClick={downloadMedia}>
              This browser does not support the HTML5 video element.
            </Image>
          </audio>
          <Image
            onClick={handleMediaPlay}
            className={cn(styles.smallCenter, {
              [styles.pointer]: value,
            })}
            src={
              value
                ? mediaPlay
                  ? images.pauseMedia.default
                  : images.playMedia.default
                : images.audioMediaPlaceholder.default
            }
          />
        </div>
      );
      // render image
    } else if (
      (value && typeof value === 'string' && value.includes('/image')) ||
      (typeof value === 'string' &&
        value.includes('http') &&
        value.includes('/media'))
    ) {
      return (
        <div key={'image-key'}>
          <Image
            src={value}
            onClick={openPortal}
            rounded={true}
            className={styles.imageIcon}
          />

          {displayPortal && (
            <Portal id="portal" type="modal">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <div className={classes.header}>
                  <IconWithText
                    onClick={closePortal}
                    component={BorderedCloseIcon}
                    theme={'light'}
                  />
                </div>

                <img
                  src={value}
                  style={{ maxWidth: '100%' }}
                  alt={'currentFileName'}
                />
              </div>
            </Portal>
          )}
        </div>
      );
      // render text
    } else if (value && typeof value === 'string') {
      return <span style={{ marginLeft: '5px' }}>{value}</span>;
    } else return null;
  };

  return renderContent(value);
};

MediaButton.propTypes = {
  value: PropTypes.string,
  condense: PropTypes.bool,
};

export default MediaButton;
